import { Text, View } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import { styles } from '../../../utils/styles';
import defaults from '../../../translations/en.json';
import { Phones } from './PatientElements';
import { parseAddress, parsePhones } from '../utils';

const parseFacilities = facs => {
  const typeGrouped = {};
  facs.forEach(fac => {
    const {
      type
    } = fac;

    if (!typeGrouped[type]) {
      typeGrouped[type] = [];
    }

    typeGrouped[type].push(fac);
  });
  return typeGrouped;
};

const typeStyle = [styles.FacesheetText, styles.pYPointOneCm, styles.fontWeightBold];
const tableStyle = [styles.row, styles.width100, styles.justifyContentAround];

const GroupedFacilities = ({
  facs
}) => {
  const groupedFacs = parseFacilities(facs);
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(groupedFacs).map(type => /*#__PURE__*/React.createElement(Fragment, {
    key: type
  }, /*#__PURE__*/React.createElement(Text, {
    style: typeStyle
  }, `${type}: `), /*#__PURE__*/React.createElement(View, {
    style: tableStyle
  }, groupedFacs[type].map(fac => /*#__PURE__*/React.createElement(Facility, {
    fac: fac,
    key: fac.name
  }))))));
};

export const AssociatedFacilities = ({
  associatedFacilities
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.borderBottomBlack]
}, /*#__PURE__*/React.createElement(Text, {
  style: styles.printerHeaderText
}, defaults.associatedFacilities), Array.isArray(associatedFacilities) ? /*#__PURE__*/React.createElement(GroupedFacilities, {
  facs: associatedFacilities
}) : /*#__PURE__*/React.createElement(Facility, {
  fac: associatedFacilities
}));

var _ref = /*#__PURE__*/React.createElement(View, null);

const Facility = ({
  fac
}) => {
  const {
    street,
    street2,
    city,
    state,
    zip
  } = parseAddress(fac);
  const phones = parsePhones(fac);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: [styles.width20]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, fac.name)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width20]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, street, street2 ? `, ${street2}` : ' ')), /*#__PURE__*/React.createElement(View, {
    style: [styles.width10]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, city)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width10]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, state, " ", zip)), /*#__PURE__*/React.createElement(View, {
    style: [styles.width20]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.FacesheetText, styles.pYPointOneCm]
  }, phones ? /*#__PURE__*/React.createElement(Phones, {
    phones: phones
  }) : _ref)));
};